import { render, staticRenderFns } from "./SongListPage.vue?vue&type=template&id=1bfc1184"
import script from "./SongListPage.vue?vue&type=script&lang=js"
export * from "./SongListPage.vue?vue&type=script&lang=js"
import style0 from "./SongListPage.vue?vue&type=style&index=0&id=1bfc1184&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports